import React from 'react';
import { FormattedMessage } from 'react-intl';

const buildText = (id, value) => (
    <FormattedMessage
        id={id}
        defaultMessage={id}
        values={{ location: value }}
    />
);

const setMessage = subtitle => ({
    hotel: subtitle
        ? buildText('bf.propertyIn', subtitle)
        : buildText('bf.property'),
    city    : subtitle ? buildText('bf.cityIn', subtitle) : buildText('bf.city'),
    state   : subtitle ? buildText('bf.stateIn', subtitle) : buildText('bf.state'),
    country : buildText('bf.country'),
    default : subtitle,
});

const handleSubtitles = (suggestions) => {
    if (suggestions?.hasSubs) {
        return suggestions;
    }
    const suggestionsWithSubtitles = suggestions?.categories.map((category) => {
        const childrenWithSubs = category.children.map((child) => {
            const { subtitle, type } = child;
            return {
                ...child,
                subtitle: setMessage(subtitle)[type] ?? setMessage(subtitle).default,
            };
        });

        return {
            ...category,
            children: [ ...childrenWithSubs ],
        };
    });
    return {
        categories           : suggestionsWithSubtitles,
        hasSubs              : true,
        containsGooglePlaces : suggestions?.containsGooglePlaces,
    };
};

export default handleSubtitles;

// i18nLabel[bf.propertyIn]
// i18nLabel[bf.property]
// i18nLabel[bf.cityIn]
// i18nLabel[bf.city]
// i18nLabel[bf.stateIn]
// i18nLabel[bf.state]
// i18nLabel[bf.country]

